<template>
    <div class="expedientes mt-1">
        <!-- <b-nav-form> -->
            <div class="row p-2">
                    <div class="col-6 col-sm-2">
                        <b-form-select v-model="bAno" :options="cbAno" size="md" @change="leemos"></b-form-select>
                    </div>
                    <div class="col-6 col-sm-3">
                        <b-form-select v-model="bDep" :options="cbDep" size="md" @change="filterExp"></b-form-select>
                    </div>
                    <div class="col-6 col-sm-2">
                        <b-form-select v-model="bStd" :options="cbStd" size="md" @change="filterExp"></b-form-select>
                    </div>
                    <div class="col-6 col-sm-4">
                        <b-form-input
                            v-model="bTxt"
                            @keypress.13="filterExp"
                            @click:append="filterExp">
                        </b-form-input>
                        <!-- <b-form-input v-model="bTxt" size="sm" class="mr-sm-2" placeholder="Busqueda ..."></b-form-input>
                        <b-button size="sm" class="my-2 my-sm-0" type="submit">BUSCAR</b-button> -->
                    </div>
                    <div class="col-12 col-sm-1">{{ rows }}</div>


            </div>
        <!-- </b-nav-form>               -->
        <b-table striped hover bordered small
            id="tablaExped"
            sticky-header="480px" head-variant="light"
            :items="exped" :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            selectable select-mode="single" @row-selected="selecciona_expediente" @row-dblclicked="selecciona"
            class="bg-white" responsive>

            <template #cell(icono)="{ item }">
                <p class="h4 mb-1">
                    <b-icon
                        v-b-tooltip.right.hover :title="iconoStd(item.std).name"
                        :icon="iconoStd(item.std).icon"
                        :variant="iconoStd(item.std).color">>
                    </b-icon>
                </p>
            </template>

            <template #cell(id)="{ item }">
                <div :class="'text-center font-weight-bold'+(item.std>3 ? ' text-danger' : ' text-dark')">
                    {{ item.id }}
                </div>
            </template>

            <!-- <template slot="cell(hotel)" slot-scope="{item: { hotel }}"> -->
            <template slot="cell(hotel)" slot-scope="{item}">
                <div :class="(item.std>3 ? 'text-danger font-italic' : 'text-dark font-weight-bold')">
                <!-- <div :class="'text-'+iconoStd(item.std).color"> -->
                    {{ item.hotel }}
                </div>
            </template>

            <template #cell(action)="{ item }">
                <b-btn size="sm" variant="light" class="p-1"
                    v-b-tooltip.hover title="Ver Expediente"
                    @click="selecciona(item)"
                    ><b-icon size='xs' icon="eye"></b-icon>
                </b-btn>
            </template>

        </b-table>
        </div>
        <!-- <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="tablaReservas"
        ></b-pagination> -->
</template>

<script>

    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: 'listaExped',
        components: {
        },
        data() {
            return {

                exped: [],
                fields: [
                    //{ key: 'action', label:'' },
                    { key: 'icono', label:'' },
                    { key: 'exp', label: 'Expediente', sortable: true },
                    { key: 'ref', label: 'Referencia', sortable: true },
                    { key: 'contrato', label: 'Descripcion / Contrato', sortable: true },
                    { key: 'icono', label:'' },

                ],

                bAno: '',
                bDep: '0',
                bStd: '0',
                bTxt: '',

                itemsAno: [],
                itemsDep: [],
                itemsStd:[
                    {value:'0', text:'(Estado)'},
                    {value:'1', text:'ACTIVO'},
                    {value:'2', text:'FINALIZADO'},
                    {value:'3', text:'ANULADO'},
                ],

                perPage: 0,
                currentPage: 1,
                ref: false,

                estados:[
                    {id:0, name:'*', icon: "arrow-up-circle", color: "info"},
                    {id:1, name:'ACTIVO', icon: "unlock-fill", color: "success"},
                    {id:2, name:'FINALIZADO', icon: "unlock-fill",   color: "danger"},
                    {id:3, name:'ANULADO', icon: "x-circle-fill", color: "danger"},
                ],

            }
        },
        computed: {
            ...mapState(['auth']),

            rows() {
                return this.exped.length;
            },


            cbAno() {
                let result=this.$util.object_array(this.itemsAno);
                var A=[]; //[{text:"Selecciona Transporte", value:null, disabled:false}];
                result.forEach(value => {
                    //let txt=(value=='*SIN TRANSPORTE'?'En mi vehiculo (Sin Bus)':"BUS - "+value);
                    A.push({text:value.name, value:value.id, disabled:false});
                });
                return A;
            },

            cbDep() {
                let result=this.$util.object_array(this.itemsDep);
                var A=[];
                result.forEach(value => {
                    A.push({text:value.name, value:value.id, disabled:false});
                });
                return A;
            },

            cbStd() {
                return this.itemsStd;
            }

        },
        mounted() {
            this.ref="hola";
            this.leemos();

        },
        methods: {
            ...mapMutations(['loading','alerta','modal']),
            ...mapActions(['exec']),

            async leemos() {
                this.loading();

                var args={ token: this.auth.token, fnt:'lista', yy: this.bAno }
                let r=await this.exec({api:'exped', arg: args });

                if (r.error) {
                    //mensaje error modal ... mostrar r.datos
                    //this.modal({tit:"RESERVAS", msg:r.datos});
                    r.datos=[];
                }
                //guardamos datos
                this.itemsExp=Object.values(r.datos[0]);
                this.itemsAno=Object.values(r.datos[1]);
                this.itemsDep=Object.values(r.datos[2]);

                this.loading(false);

                //alert(this.bAno);

                /* if (this.bAno=='') {
                    let y=new Date().getFullYear();
                    let i=(this.itemsAno[0].id!=y ? 1 : 0);
                    this.bAno=this.itemsAno[i].id;
                    } */
               // por omision ponemos el primero de la lista (normalmente año actual)
                this.bAno=this.itemsAno[0].id;
                this.bDep='0';
                this.bStd='0';
                this.bTxt='';

                this.filterExp();
            },

            filterExp() {
                var E=this.itemsExp.slice();
                var EE=E;
                let t=this.bTxt.toLowerCase();
                let d=Number(this.bDep);
                let s=Number(this.bStd);

                console.log('*filterExp',t,d,s,E);

                if (t!='') EE=E.filter(e => {
                    return (
                        e.exp.toLowerCase().includes(t)
                        ||e.ref.toLowerCase().includes(t)
                        ||e.contrato.toLowerCase().includes(t)
                        ||e.c1.toLowerCase().includes(t)
                        ||e.c2.toLowerCase().includes(t)
                    );
                });

                if (d!='0') EE=E.filter(e => { return (d==e.dep) } );
                if (s!='0') EE=E.filter(e => { return (s==Number(e.std)) } );

                this.exped=EE;
                //console.log('*filterExp',E,EE);
            },

            // seleccion de reserva (ver)
            selecciona(item) {
                this.selecciona_expediente(item);
                this.$store.state.exped=item;
            },
            selecciona_expediente(item) {
                this.$store.state.exped=item[0];
                console.log("* listaExped.selecciona_exped",item[0]);
                this.$router.push('/expediente');
            },

            iconoStd(std) {
                return this.estados[std];
            }
        }
    }
</script>